module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm5.dc40bbb1659d093fbb63eb5523a3fc56.png";